import { Component, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'app-lang-sub',
    templateUrl: './lang-sub.component.html',
    styleUrls: ['../kb-header-language.component.scss'],
    standalone: false
})
export class LangSubComponent {
  @Input('langColor') langColor: boolean;

  constructor(private elementRef: ElementRef) { }

  ngOnChanges() {
    if (this.langColor) {
      this.elementRef.nativeElement.classList.add('lang-Active-one');
    } else {
      this.elementRef.nativeElement.classList.remove('lang-Active-one');
    }
  }
}
